import styled from 'styled-components';

import { colors } from 'theme';

import { ButtonWithStyles } from './ButtonWithStyles';

export const BorderlessButton = styled(ButtonWithStyles)`
  color: ${colors.lightContentGrey};
  background-color: transparent;
  border-radius: 0;
`;
